var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50923 0.683489C7.50923 0.508951 7.4399 0.341561 7.31648 0.218143C7.19306 0.0947257 7.02567 0.0253906 6.85113 0.0253906C6.67659 0.0253906 6.5092 0.0947257 6.38579 0.218143C6.26237 0.341561 6.19303 0.508951 6.19303 0.683489V6.16764H0.70888C0.534341 6.16764 0.366951 6.23698 0.243534 6.3604C0.120116 6.48381 0.0507812 6.6512 0.0507812 6.82574C0.0507812 7.00028 0.120116 7.16767 0.243534 7.29109C0.366951 7.41451 0.534341 7.48384 0.70888 7.48384H6.19303V12.968C6.19303 13.1425 6.26237 13.3099 6.38579 13.4333C6.5092 13.5568 6.67659 13.6261 6.85113 13.6261C7.02567 13.6261 7.19306 13.5568 7.31648 13.4333C7.4399 13.3099 7.50923 13.1425 7.50923 12.968V7.48384H12.9934C13.1679 7.48384 13.3353 7.41451 13.4587 7.29109C13.5821 7.16767 13.6515 7.00028 13.6515 6.82574C13.6515 6.6512 13.5821 6.48381 13.4587 6.3604C13.3353 6.23698 13.1679 6.16764 12.9934 6.16764H7.50923V0.683489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.780f35bf9164802e41ccd38664575fbb.svg";
export { ForwardRef as ReactComponent };